import script from "./completeSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./completeSignup.vue?vue&type=script&setup=true&lang=js"

import "./completeSignup.vue?vue&type=style&index=0&id=2417eb7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2417eb7c"]])

export default __exports__